module.exports = __webpack_public_path__ + "static/img/CLAY-TUCKER.1691957.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CLAY-TUCKER.jpg
// module id = 7id/
// module chunks = 0